import Select2Multiple from 'v-select2-multiple-component';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import {
    required,
    minValue,
} from "vuelidate/lib/validators";
import store from '@/store'

export default {
    name: "DamageLossesEdit",
    components: {
        MainLayout,
        Select2Multiple,
        flatPickr,
        Loading,
    },

    data() {
        return {
            damageLossesData: {
                library_member_id: null,
                book_id: 0,
                status: null,
                description: '',
                quantity: 0,
                type: null,
            },
            currentEditedBook: {},
            getAllBooks: [],
            memberArr: null,
            bookArr: null,
            isError: false,
            submitted: false,
            isLoading: false,
            campusId: store.state.user.campus_master.campus_code,
            disabled: false,
            noDataMsg: CONFIG.NO_DATA_EXIST,
            noMemberMsg: '',
            noCategoryMsg: '',
            noBookMsg: '',
            bookTypes: CONFIG.BOOK_TYPE_VALUE,
            maxLimitBook: 0,
            bookIdStartChange: false,
            config: CONFIG,
        };
    },

    validations: {
        damageLossesData: {
            book_id: {
                required,
            },
            status: {
                required
            },
            description: {
                required,
            },
            quantity: {
                required,
                minValue: minValue(1),
            },
        },
    },

    computed: {
        isValidMember() {
            if (this.damageLossesData.library_member_id){
                if (!this.memberArr || this.memberArr.length === 0) return false;
                    return this.memberArr.some(
                        (library_member_id) => Number(library_member_id.id) === Number(this.damageLossesData.library_member_id)
                );   
            }else{
                return true;
            }
        },
        isValidBook() {
            if (!this.bookArr || this.bookArr.length === 0) return false;
            return this.bookArr.some(
                (book_id) => Number(book_id.id) === Number(this.damageLossesData.book_id)
            );
        },
        minRequired() {
            if (this.damageLossesData.type == this.bookTypes['Physical Book'] && this.damageLossesData.quantity <= 0) {
                return true;
            }
        },
        maxLimit() {
            if (this.damageLossesData.quantity > this.maxLimitBook) {
                return true;
            }
        },
        isCountableBook() {
            if (this.damageLossesData.book_id && !this.damageLossesData.book_id == 0 && this.damageLossesData.type == this.bookTypes['Physical Book']) {
                return true;
            }
        },
        hasDamageLossesData() {
            return !!(this.damageLossesData && this.damageLossesData.id != null);
        },
    },

    watch: {
        '$route.params.id'(newId, oldId) {
            if (oldId !== undefined && newId !== oldId) {
                this.loadDamageLossesEdit();
            }
        },
    },

    methods: {
        getMember(includeMemberId = null, memberName = null) {
            let $defaultSelectOption = [{
                'id': 0,
                'text': 'Select Member'
            }];
            return axios.get("/member/getList", {
                params: {
                    campus_id: this.$store.state.user.campus_id,
                }
            })
                .then(res => {
                    if (res.data.data.length > 0) {
                        this.memberArr = $defaultSelectOption.concat(res.data.data);
                    } else {
                        this.memberArr = $defaultSelectOption;
                    }

                    if (
                        includeMemberId &&
                        memberName &&
                        !this.memberArr.some(m => Number(m.id) === Number(includeMemberId))
                    ) {
                        this.memberArr = this.memberArr.concat([{
                            id: includeMemberId,
                            text: memberName,
                        }]);
                    }
                }).catch((error) => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    throw error;
                });
        },

        getBookList() {
            const campusId = this.$store.state.user.campus_id;
            return axios.get(`book/list`, {
                params: {
                    campusId: campusId
                }
            })
                .then((res) => {
                    const filterEbook = res.data.data.filter(book => book.type != this.bookTypes['Ebook']);
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Book'
                    }];

                    if (res.data && res.data.data && filterEbook.length) {
                        let bookOptions = filterEbook.map(book => {
                            return {
                                id: book.id,
                                text: book.title
                            };
                        });

                        filterEbook.forEach(book => {
                            this.getAllBooks[book.id] = book;
                        });
                        this.bookArr = $defaultSelectOption.concat(bookOptions);
                        this.noBookMsg = '';
                        this.setMaxLimitBook();
                    } else {
                        this.bookArr = $defaultSelectOption;
                        this.noBookMsg = 'No Book for this campus.';
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status === 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else {
                        console.error("Error fetching book list:", error);
                    }
                    throw error;
                });
        },

        onMemberChange(selectedMember) {
            if (selectedMember.id === null) {
                this.damageLossesData.library_member_id = null;
            } else {
                this.damageLossesData.library_member_id = selectedMember.id;
            }
        },

        getDetail() {
            return axios.get('damageAndLoss/detail/' + this.$route.params.id)
                .then((response) => {
                    if (response.data && response.data.id != null) {
                        this.damageLossesData = response.data;
                        this.damageLossesData.type = this.bookTypes["Physical Book"];
                        this.currentEditedBook = JSON.parse(JSON.stringify(response.data));
                        this.currentEditedBook.type = this.bookTypes["Physical Book"];
                        this.setMaxLimitBook();
                        return this.getMember(
                            this.damageLossesData.library_member_id,
                            this.damageLossesData.student_name
                        );
                    }

                    this.damageLossesData = this.getEmptyDamageLossesData();
                    this.currentEditedBook = {};
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.damageLossesData = this.getEmptyDamageLossesData();
                    this.currentEditedBook = {};
                    console.log("Damage and Losses Detail API Error", error);
                    throw error;
                });
        },

        validateForm() {
            this.errors = {};
            const integerValidator = (value) => Number.isInteger(Number(value));

            if (!integerValidator(this.damageLossesData.library_member_id)) {
                this.errors.library_member_id = 'Library Member must be an integer.';
            } else if (!this.isValidMember) {
                this.errors.library_member_id = 'Selected Library Member is not valid.';
            }
            
            if (this.minRequired) {
                this.errors.book_id = 'Quantity must be at least one.';
            } else if (this.maxLimit) {
                this.errors.book_id = 'Quantity must be less than quantity of book.';
            }
            return this.errors;
        },

        update() {
            if (this.disabled) return;
            this.submitted = true;
            if (this.$v.$invalid || this.isError) {
                this.disabled = false;
                return;
            }

            if (Object.keys(this.validateForm()).length) {
                this.disabled = false;
                return;
            }

            this.disabled = true;

            // Convert 0 to null before sending
            const memberId = this.damageLossesData.library_member_id;
            const payload = {
                ...this.damageLossesData,
                library_member_id: (memberId === '0' || memberId === 0) ? null : memberId
            };

            axios.post(`damageAndLoss/update/${this.$route.params.id}`, payload)
                .then(res => {
                    if (res.data.success) {
                        this.$notification.success("Damage and Loss Updated Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.$router.push({ name: "damageLossesList" });
                    } else {
                        this.disabled = false;
                        this.$notification.error(res.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                })
                .catch(error => {
                    this.disabled = false;
                    this.isLoading = false;
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    if (error.response && error.response.status === 422) {
                        this.$notification.error("Validation Error: " + error.response.data.message, {
                            timer: 5,
                            position: "bottomCenter"
                        });
                    }
                });
        },

        changeBook() {
            const book = this.getAllBooks[this.damageLossesData.book_id];
            if (!book) return;

            this.damageLossesData.type = book.type;
            this.damageLossesData.quantity = 0;
            this.bookIdStartChange = true;

            if (this.damageLossesData.book_id == this.currentEditedBook.book_id) {
                this.maxLimitBook = Number(book.remaining_quantity) + Number(this.currentEditedBook.quantity);
            } else {
                this.maxLimitBook = Number(book.remaining_quantity);
            }
        },

        getEmptyDamageLossesData() {
            return {
                library_member_id: null,
                book_id: 0,
                status: null,
                description: '',
                quantity: 0,
                type: null,
            };
        },

        setMaxLimitBook() {
            const bookId = this.currentEditedBook && this.currentEditedBook.book_id;
            const editedBook = bookId ? this.getAllBooks[bookId] : null;
            if (!editedBook) {
                return;
            }
            this.maxLimitBook = Number(editedBook.remaining_quantity) + Number(this.currentEditedBook.quantity);
        },

        async loadDamageLossesEdit() {
            this.isLoading = true;
            this.submitted = false;
            this.disabled = false;
            this.damageLossesData = this.getEmptyDamageLossesData();
            this.currentEditedBook = {};
            this.maxLimitBook = 0;
            try {
                await this.getBookList();
                await this.getDetail();
            } catch (error) {
                console.error("Damage and Loss edit load failed:", error);
            } finally {
                this.isLoading = false;
            }
        },
    },

    async mounted() {
        await this.loadDamageLossesEdit();
    },
};
